import { AnunciosData, GetVoidAnunciosData } from "../Anuncio/AnuncioData";
import { Gestor, GetVoidGestor } from "./Gestor";

export interface AprobacionData {
    gestor: Gestor,
    anuncio: AnunciosData
}

export function GetVoidAprobacionData(): AprobacionData{
    return {
        gestor: GetVoidGestor(),
        anuncio: GetVoidAnunciosData()
    }
}